import * as Icons from "./Icons";
import { FLAVORS } from "../flavor.constants";

export const Icon = ({ name, social = false }: { name: any, social?: boolean }) => {
  const flavName = !FLAVORS.includes(name) && !social ? 'Default' : name

  // @ts-ignore
  const Component = Icons[flavName]

  return (
    <div className="iconContainer">
      <Component />
    </div>
  );
};
